import cn from "classnames";
import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useTranslation } from "react-i18next";
import { Pagination } from "ui";

import { AuditAlertsTable } from "../../components";
import { AuditAlertsTab } from "../../constants";
import { useAuditAlertsList } from "../../hooks";

import styles from "./AuditAlerts.module.scss";

const AuditAlerts = () => {
  const { t } = useTranslation();

  const {
    auditAlerts,
    totalItems,
    tab,
    setTab,
    page,
    setPage,
    sorting,
    setSorting,
    isLoading
  } = useAuditAlertsList();

  const tabs = [
    { key: AuditAlertsTab.Unreviewed, label: t("Unreviewed") },
    { key: AuditAlertsTab.All, label: t("All") }
  ];

  return (
    <ContentLayout title={t("Critical Action Alerts")}>
      <BoxShadowLayout className={styles.alerts}>
        <div className={styles.alerts__tabs}>
          {tabs.map(({ key, label }) => (
            <button
              key={key}
              type="button"
              className={cn(styles.alerts__tab, {
                [styles["alerts__tab--active"]]: tab === key
              })}
              onClick={() => setTab(key)}
            >
              {label}
            </button>
          ))}
        </div>

        <AuditAlertsTable
          auditAlerts={auditAlerts ?? []}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
        />

        <Pagination
          currentPage={page}
          onChange={setPage}
          perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
          totalItems={totalItems}
        />
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default AuditAlerts;
